import React from 'react';

/**
 * LocationCardSkeleton component for displaying a loading state for location cards
 * 
 * @returns {JSX.Element} - LocationCardSkeleton component
 */
const LocationCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse">
      {/* Image placeholder */}
      <div className="relative">
        <div className="h-48 bg-gray-200"></div>
      </div>
      
      {/* Content and Map in 50/50 split */}
      <div className="relative">
        <div className="flex flex-row">
          {/* Left side - Content placeholders */}
          <div className="w-3/5 p-6">
            {/* Title placeholder */}
            <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
            
            {/* Address placeholder */}
            <div className="flex mb-4">
              <div className="h-3 w-3 bg-gray-200 rounded-full mr-1.5 flex-shrink-0 mt-1"></div>
              <div className="flex flex-col w-full">
                <div className="h-3 bg-gray-200 rounded w-full mb-1"></div>
                <div className="h-3 bg-gray-200 rounded w-4/5"></div>
              </div>
            </div>
            
            {/* View details placeholder */}
            <div className="flex items-center">
              <div className="h-4 bg-gray-200 rounded w-20"></div>
              <div className="h-4 w-4 bg-gray-200 rounded-full ml-1"></div>
            </div>
          </div>
          
          {/* Right side - Map placeholder */}
          <div className="w-2/5 relative p-4 pt-0">
            <div className="relative -mt-4 pb-[100%]"> {/* 1:1 aspect ratio */}
              <div className="absolute inset-0 p-3 bg-white rounded-xl shadow-md">
                <div className="w-full h-full rounded-md border border-gray-200 bg-gray-300"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCardSkeleton;
